import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import {  Content, Container } from "./styled";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import FormularioParceiros from "../../../../../components/Admin/Pocketbook/parceiros/Criar/Formulario";
import Back from "../../../../../components/Admin/Pocketbook/parceiros/Criar/Back";
import { Box } from "@material-ui/core";

const CadastroParceiros = (props) => {
  return (
    <Container>

    {/* // <Box width="100%" paddingLeft="250px">
    // <Box width="100%" padding="1rem"> */}
      <Content>
      <AdminMenu />
        <Back />
        <h2>Cadastrar Parceiro</h2>
        <Divider />
        <Segment>
          <FormularioParceiros />
        </Segment>
        </Content>
    {/* // </Box>
    // </Box> */}
    </Container>
  );
};

export default withRouter(CadastroParceiros);
